// Internationalization strings for the app
// Note: Expert booking and availability strings have been removed

export const strings = {
  // App name
  finline: 'Finline',
  fyntrai: 'Fyntrai',

  // Onboarding
  onBoardingTitleText1: 'All in One Investment Platform',
  onBoardingTitleText2: 'Track Prices On All Investment',
  onBoardingTitleText3: 'Stretch Out Your Payments Over Time',
  onBoardingTitleText4: 'Enter for a Chance to Win You Share $1M Assets',
  onBoardingDescriptionText1: 'Diversity your investment from cryptocurrency, NFTs, Gold, and stock in one app',
  onBoardingDescriptionText2: 'Set up automatic price alerts to let you know about price movements for a specific asset.',
  onBoardingDescriptionText3: 'Massa enim rhoncus quis magna. Fames mi dignissim cursus sit. Malesuada pulvinar enim a vitae urna volutpat.',
  onBoardingDescriptionText4: 'Each time the friends you invite buy or sells, you get a 0.020%. Commission is calculated from the value of buy or sell purchase.',
  getStarted: 'Get Started',
  browseAssets: 'Browse Assets',
  skip: 'Skip',

  // Authentication
  continueWithEmail: 'Continue with Email',
  continueWithPhoneNumber: 'Continue with Phone Number',
  doHaveAnAccount: "Don't have an account? ",
  signUp: ' Sign Up',
  userDetails: 'User Details',
  continueWithGoogle: 'Continue With Google',
  continueWithApple: 'Continue With Apple',
  continueWithFB: 'Continue With Facebook',
  welcomeBack: 'Welcome Back!',
  signInToYourAccount: 'Sign in to your account',
  email: 'Email',
  phoneNumber: 'Phone Number',
  password: 'Password',
  otp: 'Enter OTP',
  thisFieldIsMandatory: 'This Field Is Mandatory',
  enterStrongPassword: 'Please Enter Strong Password',
  enterValidEmail: 'Please Enter Valid Email',
  forgotPassWord: 'Forgot Password?',
  resendOTP: 'Resend OTP',
  rememberMe: 'Remember me',
  signIn: 'Sign In',
  getOTP: 'Get OTP',
  verifyOTP: 'Verify OTP',
  orSignInWith: 'Or Sign In With',
  google: 'Google',
  apple: 'Apple',
  facebook: 'Facebook',
  createYourAccount: 'Create your account',
  accountText: "Let's get started with a free Financy account.",
  fullName: 'Full name',
  companyName: 'Company Name',
  profileHeadline: 'Profile Headline',
  description: 'Description',
  sebiQualification: '* SEBI Qualification',
  sebiRegisteredNumber: '* SEBI Registered Number',
  languages: 'Languages',
  yearsOfExperience: 'Years of Experience',
  agreementText: "I certify that I'm 18 years of age or older, and I agree to the",
  userAgreement: 'User Agreement ',
  and: 'and',
  orSignUpWith: 'Or Sign Up With',
  loginText: 'Already have an account?',
  almostDone: 'Almost Done!',
  enterPhoneNumberText: "Enter your phone number and we'll text you a code to activate your account.",
  continue: 'Continue',
  mobileNumber: 'Mobile Number',
  authenticationCode: 'Authentication Code',
  otpDescription: 'Enter 5-digit code we just texted to your phone number',
  resendCode: 'Resend Code',
  useDifferentPhoneNumber: 'Use different phone number',
  createNewPassword: 'Create New Password',
  newPasswordDescription: 'Your new password must different from previous password.',
  resetPassword: 'Reset Password',
  confirmPassword: 'Confirm Password',
  passwordUpdated: 'Password Updated!',
  updatePasswordDescription: 'Your password has been set up successfully.',
  backToSignIn: 'Back to Sign In',
  alreadyHaveAccount: 'Already have an account? ',
  plsEnterPassword: 'Please Enter Password',
  invalidPassword: 'Please Enter valid Password',
  validatePassword: 'Password must contain 8-40 characters, 1 Uppercase(A-Z), 1 lowercase (a-z), 1 number (0-9), and a special character except space.',
  confirmPassValidString: 'Password does not match.',

  // Biometric
  enableFaceID: 'Enable Face ID',
  enableFaceIdDescription: "This help us check that you're really you. Identity verification is one of the ways we keep secure.",
  skipForNow: 'Skip for Now',
  enableFingerprint: 'Enable Fingerprint',
  enableFingerprintDescription: 'Enable your fingerprint authentication as your security.',

  // Country/Citizenship
  whatsYourCitizenship: "What's your citizenship?",
  citizenDescription: "If you're a citizen of more than one country, please pick one.",
  citizenship: 'Citizenship',
  selectYourCountry: 'Select your country',
  selectCountry: 'Select Country',
  unitedStates: 'United States',
  unitedKingdom: 'United Kingdom',
  india: 'India',
  ukraine: 'Ukraine',
  uruguay: 'Uruguay',
  securityText: 'This info is used only for identity verification and is transmitted securely using 128-bit encryption.',

  // Usage reasons
  whatDoYouWantUseFinancialFor: 'What do you want to use Financial for?',
  selectReasonDescription: 'We need to know this for regulatory reasons. And also, we need curious!',
  banking: 'Banking',
  transfers: 'Transfers',
  schedulingPayments: 'Scheduling Payments',
  getSalaryEarly: 'Get salary early',
  budgeting: 'Budgeting',
  cashback: 'Cashback',
  viewAccountOnePlace: 'View account in one place',
  investments: 'Investments',
  investGold: 'Invest in gold',
  investCryptocurrency: 'Invest in cryptocurrency',
  investStocks: 'Invest in stocks',
  trading: 'Trading',
  NFTs: 'NFTs',
  globalSpending: 'Global Spending',
  spendingAbroad: 'Spending abroad',
  travelInsurance: 'Travel insurance',
  foreignExchanges: 'Foreign exchanges',

  // PIN
  createPIN: 'Create a PIN',
  createPINDescription: 'Set PIN code to your Financial card.',
  createPin: 'Create PIN',

  // Document Upload
  selectUpload: 'Select and upload',
  selectUploadDescription: 'We need this to confirm you reside in United States and verify who you are. Data is processed securely.',
  identityCard: 'Identity Card',
  myDigitalDocument: 'My Digital Document',
  myPassport: 'My Passport',
  verifyYourIdentity: 'Verify Your Identity',
  identityVerifyDescription: 'To help protect you from fraud and identity theft, and to comply with federal regulations, we need some info.',
  takeSelfieWithIDCard: 'Take a Selfie with ID Card',
  pleaseLookAtCameraAndHoldStill: 'Please look at the camera and hold still',
  takePicture: 'Take Picture',
  retakePicture: 'Retake Picture',
  thanksForSubmittingYourSelfieWithIDCard: 'Thanks for submitting your Selfie with ID Card',
  verifySuccessDescription: 'We can review it now, Wait a few moments we will verify it as soon as possible.',

  // Navigation
  home: 'Home',
  market: 'Market',
  portfolio: 'Portfolio',
  profile: 'Profile',
  wallet: 'Wallet',
  financial: 'Financial',

  // Home
  totalAssetValue: 'Total asset value',
  profits: 'Profits',
  stock: 'Stocks',
  crypto: 'Crypto',
  gold: 'Gold',
  watchList: 'Watchlist',
  editWatchList: 'Edit watchlist',
  cryptoAssets: 'Crypto Assets',
  uSStocks: 'US Stocks',
  topGainers: 'Top Gainers',
  seeAll: 'See All',
  latestNews: 'Latest News',
  search: 'Search...',

  // Companies/Stocks
  abab: 'ABNB',
  airbnbInc: 'Airbnb, Inc.',
  spot: 'SPOT',
  spotifyTechnology: 'Spotify Technology',
  shib: 'SHIB',
  ada: 'ADA',
  shibaInu: 'Shiba Inu',
  cardano: 'Cardano',
  polygon: 'Polygon',
  bnb: 'Bnb',
  solana: 'Solana',
  matic: 'MATIC',
  bnbs: 'BNB',
  sol: 'SOL',
  btc: 'BTC',
  bitcoin: 'Bitcoin',
  eth: 'ETH',
  ethereum: 'Ethereum',
  usdt: 'USDT',
  usdCoin: 'USD Coin',
  tether: 'Tether',
  bch: 'BCH',
  bitcoinCash: 'Bitcoin Cash',
  band: 'BAND',
  bandProtocol: 'Band Protocol',

  // Market
  livePrices: 'Live Prices',
  sort: 'Sort',
  all: 'All',
  open: 'Open',
  volume: 'Volume',
  high: 'High',
  avgVol: 'Avg Vol',
  low: 'Low',
  mktCap: 'Mkt Cap',
  wRange: '52W Range',
  supply: 'Supply',
  price: 'Price',
  currentBid: 'Current Bid',

  // Portfolio
  send: 'Send',
  receive: 'Receive',
  buySell: 'Buy / Sell',
  exchange: 'Exchange',
  gainLoss: 'Gain / Loss',

  // Wallet
  deposit: 'Deposit',
  withdraw: 'Withdraw',
  transfer: 'Transfer',
  balance: 'Balance',
  availableBalance: 'Available Balance',

  // Profile
  accountDetails: 'Account Details',
  personalDetails: 'Personal Details',
  yourAccountInformation: 'Your account information',
  identifyVerification: 'Identity Verification',
  yourVerificationStatus: 'Your verification status',
  transactionHistory: 'Transaction History',
  yourTransactionDetails: 'Your transaction details',
  bankAccount: 'Bank Account',
  manageYourBankAccount: 'Manage your bank account',
  features: 'Features',
  mission: 'Mission',
  getMoreRewards: 'Get more rewards',
  autoInvest: 'Auto Invest',
  manageAutoInvestment: 'Manage auto investment',
  settings: 'Settings',
  privacySecurity: 'Privacy & Security',
  pinBiometricProtection: 'PIN & Biometric protection',
  pushNotifications: 'Push Notifications',
  notificationPreferences: 'Notification preferences',
  language: 'Language',
  english: 'English',
  darkMode: 'Dark Mode',
  darkModeValue: 'Dark mode value',
  others: 'Others',
  helpCenter: 'Help Center',
  getSupports: 'Get supports',
  termsConditions: 'Terms & Conditions',
  ourTermsConditions: 'Our terms & conditions',
  privacyPolicy: 'Privacy Policy',
  ourPrivacyPolicy: 'Our privacy policy',
  refundAndCancellation: 'Refund & Cancellation',
  ourRefundPolicy: 'Our refund policy',
  aboutApp: 'About App',
  ourApplication: 'Our application',
  logOut: 'Log Out',

  // Bank
  bankOfAmerica: 'Bank of America',
  barclays: 'Barclays',
  addNewBankAccount: 'Add New Bank Account',
  accountHolderName: 'Account Holder Name',
  accountNumber: 'Account Number',
  ifscCode: 'IFSC Code',
  bankName: 'Bank Name',
  addBankAccount: 'Add Bank Account',

  // Common
  save: 'Save',
  cancel: 'Cancel',
  delete: 'Delete',
  edit: 'Edit',
  done: 'Done',
  next: 'Next',
  back: 'Back',
  confirm: 'Confirm',
  submit: 'Submit',
  ok: 'OK',
  yes: 'Yes',
  no: 'No',
  close: 'Close',
  filter: 'Filter',
  apply: 'Apply',
  clear: 'Clear',
  loading: 'Loading...',
  success: 'Success',
  error: 'Error',
  warning: 'Warning',
  info: 'Info',

  // Time
  today: 'Today',
  yesterday: 'Yesterday',
  thisWeek: 'This Week',
  thisMonth: 'This Month',
  thisYear: 'This Year',

  // Notifications
  notifications: 'Notifications',
  markAsRead: 'Mark as Read',
  noNotifications: 'No notifications',

  // FAQ
  faq: 'FAQ',
  frequentlyAskedQuestions: 'Frequently Asked Questions',
};

export default strings;
